<template>
    <div @mouseup="handleSearchText" ref="textContainer" @click="handleClick">
        <!-- 这里是你的文本内容 -->
        <simple-code :data="text"/>
    </div>
</template>

<script setup>
    import { ref } from 'vue';
    import { defineProps } from 'vue';
    import SimpleCode from "../components/SimpleCode";
    const props = defineProps({
        text: {
            type: String,
            default: ''
        },
        refs: {
            type: Array,
        },
        handleMinus: {
            type: Function
        }
    });
    const selectedText = ref('');
    const popText = ref('');
    const textContainer = ref(null);
    const showPopover = ref(false);
    const popoverStyle = ref({
        top: '0px',
        left: '0px'
    });
    // // 处理划词逻辑
    // const vSelection = {
    //     mounted(el) {
    //         el.addEventListener('mouseup', handleMouseUp);
    //     },
    //     beforeUnmount(el) {
    //         el.removeEventListener('mouseup', handleMouseUp);
    //     }
    // };
    // 获取弹窗文字
    const getPopText = () => {
        let refs = props.refs;
        let minus = refs.find(r=>r.name === selectedText.value) || {};
        let {paragraph} = minus;
        console.log('props');
        popText.value = paragraph;
        if(props.handleMinus) props.handleMinus(minus);
    };

    // const selectedTextElement = document.getElementById('selectedText');
    const directionIndicator = document.getElementById('directionIndicator');
    const handleClick = (event) => {
        // 检查点击的是否是a标签
        if (event.target.tagName === 'A') {
            // 阻止a标签的默认跳转行为（如果需要）
            event.preventDefault();
            // 在这里处理你的自定义逻辑
            let {textContent} = event.target;
            handleText(textContent);
            // handleMouseUp();
            // 你可以访问event.target上的属性，如href、textContent等

        }
    };

    // 处理文本选择
    function handleSearchText() {
        const selection = window.getSelection();
        const text = selection.toString().trim();

        if (text) {
            props.handleSearch(text);
        }
    }

    // 处理文本选择
    function handleText(text) {
        const selection = window.getSelection();
        if (text) {
            selectedText.value = text;
            getPopText();
            // 获取选择范围的位置
            const range = selection.getRangeAt(0);
            const rect = range.getBoundingClientRect();

            // 确定最佳弹窗方向
            const direction = calculateBestDirection(rect);

            // 显示弹窗并定位
            positionPopover(rect, direction);

            // 高亮选中的文本
            highlightSelection(range);

            // 更新方向指示器
            if(directionIndicator)directionIndicator.textContent = getDirectionName(direction);
        }
    }
    // 获取方向名称
    function getDirectionName(direction) {
        const names = {
            'top': '向上',
            'bottom': '向下',
            'left': '向左',
            'right': '向右'
        };
        return names[direction] || '未知';
    }
    // 计算最佳弹窗方向
    function calculateBestDirection(rect) {
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        // 计算到各边界的距离
        const toTop = rect.top;
        const toBottom = viewportHeight - rect.bottom;
        const toLeft = rect.left;
        const toRight = viewportWidth - rect.right;

        // 计算各方向的可用空间
        const spaceAbove = toTop - 20;
        const spaceBelow = toBottom - 20;
        const spaceLeft = toLeft - 20;
        const spaceRight = toRight - 20;

        // 弹窗的估计尺寸
        const popoverWidth = 500;
        const popoverHeight = 180;

        // 检查各方向是否有足够空间
        const canShowAbove = spaceAbove >= popoverHeight;
        const canShowBelow = spaceBelow >= popoverHeight;
        const canShowLeft = spaceLeft >= popoverWidth;
        const canShowRight = spaceRight >= popoverWidth;

        // 确定最佳方向（优先上下，其次左右）
        if (canShowBelow) {
            return 'bottom';
        } else if (canShowAbove) {
            return 'top';
        } else if (canShowRight) {
            return 'right';
        } else if (canShowLeft) {
            return 'left';
        } else {
            // 如果没有足够空间，默认显示在下方
            return 'bottom';
        }
    }

    // 定位弹窗
    function positionPopover(rect, direction) {
        const scrollX = window.scrollX;
        const scrollY = window.scrollY;
        showPopover.value = true;
        // 根据方向计算位置
        switch (direction) {
            case 'top':
                popoverStyle.value = {
                    top: `${rect.top + scrollY - 190}px`,
                    left: `${rect.left + window.scrollX + rect.width/2}px`,
                    transform: 'translateX(-50%)'
                };
                break;
            case 'bottom':
                popoverStyle.value = {
                    top: `${rect.top + scrollY + 10}px`,
                    left: `${rect.left + window.scrollX + rect.width/2}px`,
                    transform: 'translateX(-50%)'
                };
                break;
            case 'left':
                popoverStyle.value = {
                    top: `${rect.top + scrollY + rect.height/2}px`,
                    left: `${rect.left + scrollX - 310}px`,
                    transform: 'translateX(-50%)'
                };
                break;
            case 'right':
                popoverStyle.value = {
                    top: `${rect.top + scrollY + rect.height/2}px`,
                    left: `${rect.right + scrollX + 10}px`,
                    transform: 'translateX(-50%)'
                };
                break;
        }

    }
    // 高亮选中的文本
    function highlightSelection(range) {
        // 清除之前的高亮
        removeHighlights();

        const selectedContent = range.extractContents();
        const span = document.createElement('span');
        span.className = 'selection-highlight';
        span.appendChild(selectedContent);
        range.insertNode(span);
    }
    // 移除所有高亮
    function removeHighlights() {
        const highlights = textContainer.value.querySelectorAll('.selection-highlight');
        highlights.forEach(highlight => {
            const parent = highlight.parentNode;
            parent.replaceChild(document.createTextNode(highlight.textContent), highlight);
            parent.normalize();
        });
    }
</script>

<style scoped>

</style>